import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const StarIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'currentColor',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <path
        d="M12 1.5L9 8.5L2 9.5L7 14.5L6 22L12.5 19L18.5 22L17 14.5L22 9.5L15 8.5L12 1.5Z"
        fill={getColor(secondaryColor)}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0.00418091L15.6698 7.80049L23.7613 9.06922L17.9245 15.0319L19.3027 23.5913L12 19.5423L4.68824 23.5963L6.10781 15.0319L0.231758 9.0703L8.33016 7.80049L12 0.00418091ZM12 3.99581L9.48427 9.3403L3.76825 10.2366L7.92656 14.4554L6.94063 20.4037L12 17.5985L17.0684 20.4087L16.1098 14.4555L20.2387 10.2376L14.5157 9.3403L12 3.99581Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default StarIconFilled;
